import React, { useEffect } from 'react';
import { Box, CircularProgress, alpha, TextField, Typography, useTheme } from '@mui/material';
import LegalAnnoucementSuggestion from '@europrocurement/l2d-modules/modules/Dossiers/components/detail/LegalAnnoucementSuggestion/LegalAnnoucementSuggestion';
import { PrestationAnnonceLgaleApiGetListTblPrestaPrestationAnnonceLgaleCollectionRequest } from '@europrocurement/l2d-domain/openApi/ApiAnnoncesLegales';
import { type DossierArticle, useSearchLegalAnnoucement } from '@europrocurement/l2d-modules';

export type SelectLegalAnnoucementFormProps = {
    processing: boolean;
    onItemSelected: (idLegalAnnoucement: number, articleId: number) => void;
    article: DossierArticle;
    title?: string;
    placeholder?: string;
    filters?: PrestationAnnonceLgaleApiGetListTblPrestaPrestationAnnonceLgaleCollectionRequest;
    sTypeId?: number;
};

const SelectLegalAnnoucementForm: React.FunctionComponent<SelectLegalAnnoucementFormProps> =
    function (props) {
        const {
            processing,
            onItemSelected,
            article,
            filters,
            sTypeId,
            title = 'Rechercher une annonce légale',
            placeholder = 'Rechercher une annonce légale',
        } = props;
        const { suggestions, searching, setSearchTerm, selectSuggestion, setFilters } =
            useSearchLegalAnnoucement(sTypeId);
        const { palette } = useTheme();
        const handleSelectSuggestion = (id: number) => {
            if (!processing) {
                selectSuggestion(id);
                onItemSelected(id, article.id);
            }
        };

        useEffect(() => {
            if (filters) {
                setFilters(filters);
            }
            // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [filters]);

        return (
            <Box sx={{ minWidth: '480px' }}>
                <Typography variant="l2dh6">{title}</Typography>
                <Box
                    sx={{
                        padding: '26px 0',
                        display: 'flex',
                        flexDirection: 'column',
                        rowGap: '10px',
                        position: 'relative',
                    }}
                >
                    <Box sx={{ position: 'relative' }}>
                        <TextField
                            sx={{ width: '100%' }}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            placeholder={placeholder}
                        />
                        {searching && (
                            <CircularProgress
                                color="primary"
                                size="16px"
                                sx={{
                                    position: 'absolute',
                                    right: '20px',
                                    top: '50%',
                                    marginTop: '-8px',
                                }}
                            />
                        )}
                    </Box>
                    {processing && (
                        <Box
                            sx={{
                                position: 'absolute',
                                top: '85px',
                                left: '0',
                                width: '100%',
                                height: '50vh',
                                background: alpha(palette.background.default, 0.5),
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                            }}
                        >
                            <CircularProgress
                                color="primary"
                                size="48px"
                            />
                        </Box>
                    )}
                    <Box sx={{ height: '50vh', overflow: 'auto' }}>
                        {suggestions.map((suggestion) => (
                            <LegalAnnoucementSuggestion
                                key={suggestion.id}
                                {...suggestion}
                                onClick={() => handleSelectSuggestion(suggestion.id)}
                            />
                        ))}
                    </Box>
                </Box>
            </Box>
        );
    };

export default SelectLegalAnnoucementForm;
